import { createAction, props } from '@ngrx/store';
import { ReportDataParams } from '../../../core/services/gse/reports/report-data.service';

export const loadReportData = createAction(
  '[Report] Load Report Data',
  props<{ reportType: string; params: ReportDataParams }>()
);

export const loadReportDataSuccess = createAction(
  '[Report] Load Report Data Success',
  props<{ data: any[]; totalRecords: number }>()
);

export const loadReportDataFailure = createAction(
  '[Report] Load Report Data Failure',
  props<{ error: string }>()
);

export const exportReport = createAction(
  '[Report] Export Report',
  props<{ reportType: string; params: ReportDataParams }>()
);

export const exportReportSuccess = createAction(
  '[Report] Export Report Success'
);

export const exportReportFailure = createAction(
  '[Report] Export Report Failure',
  props<{ error: string }>()
);

export const resetReportState = createAction(
  '[Report] Reset Report State'
);
